import { render, staticRenderFns } from "./topLevel.vue?vue&type=template&id=52351daa&"
import script from "./topLevel.vue?vue&type=script&lang=js&"
export * from "./topLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports